// @flow
import * as React from 'react';
import type { FileUploadTypes } from 'api/shared';
import FilePicker from 'components/FilePicker';
import Field from './Field';

const FileUploadField = ({
  downloadAttachment,
  fileType = 'CMS_UPLOAD',
  name,
  label,
  description,
  onUpdateValue,
  'data-qa-id': qaId,
  onError,
  large,
  ...props
}: {
  downloadAttachment?: boolean,
  fileType?: FileUploadTypes,
  name: string,
  label?: string,
  description?: string,
  message?: string,
  'aria-label'?: string,
  'data-qa-id'?: string,
  onUpdateValue?: Function,
  onError?: Error => void,
  large?: boolean,
  accept?: string
}) => (
  <Field
    {...props}
    name={name}
    label={label}
    description={description}
    inputProps={props}
    renderInput={({ value, qaId: autoQaId, updateValue }) => (
      <FilePicker
        downloadAttachment={downloadAttachment}
        fileId={value}
        fileType={fileType}
        value={value || ''}
        data-qa-id={qaId || autoQaId}
        onChange={e => {
          if (onUpdateValue) {
            onUpdateValue(e);
          } else {
            updateValue(e);
          }
        }}
        onError={onError}
        name={name}
        large={large}
        {...props}
      />
    )}
  />
);

export default FileUploadField;
